import React, { useEffect, useRef } from 'react';
import { Parser } from 'html-to-react';
import { Between, Line, ButtonSmall, ButtonLink, Center, IconSmall, LabelBig, LabelSubTitle, Paragraph, Row } from 'meitav-uikit';
import dialogIcon from "images/dialogIcon.png";

const PopUpContradiction = props => {

  const p = new Parser();

  const handleClose = () => {
    if (props.CloseContradiction()) {
      props.CloseContradiction();
    }
    window.popupClose();
  }


  return (
    <Row>
      <Center>
        <IconSmall src={dialogIcon} />
        <Paragraph>{p.parse(props?.contradictionText)}</Paragraph>
      </Center>
    </Row>
  );
};

export default PopUpContradiction;
